import React from 'react'
import { PageTitle } from '../../../_metronic/layout/core'
import AddDr from './AddDr'

const AddDrWrapper = () => {
    return (
        <>{
            window.location.pathname === "/admin/edit_doctor" ?
                <PageTitle breadcrumbs={[]}> Edit Doctor </PageTitle>
                :
                <PageTitle breadcrumbs={[]}> Add Doctor </PageTitle>
        }
            <AddDr />
        </>
    )
}

export default AddDrWrapper